import { useMemo } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { FONT_SERIF, WD } from '../../../warningDashboard/warningTheme';
import { FIGURE, LOAD_ORDER } from '../utils/constants';
import { formatLong } from '../utils/dates';
import { fmtHours, summariseHours } from '../utils/hours';
import Panel from './Panel';
import LoadTag from './LoadTag';
import DayPersonButton from './DayPersonButton';

/** The calendar's selected day, person by person, grouped by load level. */
export default function DayPanel({ day, people, tasks, idx, today, projectId, onOpenPerson, onOpenDay }) {
  const summary = useMemo(() => summariseHours({ people, tasks, idx, from: day, to: day, projectId }), [people, tasks, idx, day, projectId]);
  const { totals } = summary;

  return (
    <Panel sx={{ p: 2.5 }}>
      <Box display="flex" alignItems="flex-start" justifyContent="space-between" gap={2}>
        <Box>
          <Typography component="h3" sx={{ fontSize: 15, fontWeight: 700, color: WD.ink }}>{formatLong(day)}</Typography>
          <Typography sx={{ mt: 0.25, fontSize: 12, color: WD.inkMuted }}>
            {day === today ? 'Today · ' : ''}
            {fmtHours(totals.allocated)} allocated of {fmtHours(totals.capacity)}
          </Typography>
        </Box>
        <Typography sx={{ fontFamily: FONT_SERIF, fontSize: 28, fontWeight: 600, lineHeight: 1, color: WD.ink, ...FIGURE }}>
          {totals.capacity ? `${Math.round(totals.utilisation)}%` : '-'}
        </Typography>
      </Box>

      {totals.capacity ? (
        <Box sx={{ mt: 2, display: 'grid', gap: 2 }}>
          {LOAD_ORDER.filter((key) => summary.levels[key] > 0).map((key) => (
            <Box key={key}>
              <LoadTag level={key} small />
              <Box sx={{ mt: 0.75, display: 'grid', gap: 0.25 }}>
                {summary.rows
                  .filter((row) => row.level === key && row.capacity > 0)
                  .map((row) => (
                    <DayPersonButton key={row.person.id} row={row} onOpen={onOpenPerson} />
                  ))}
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography sx={{ mt: 2, fontSize: 13, color: WD.inkFaint }}>A day off for everyone on this page.</Typography>
      )}

      <Button fullWidth variant="contained" onClick={() => onOpenDay(day)} sx={{ mt: 2.5, py: 1 }}>
        Open day view
      </Button>
    </Panel>
  );
}
